<ion-app
  [ngClass]="fsValue"
  style="
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    -webkit-touch-callout: default;
  "
>
  <app-side-menu></app-side-menu>
  <ion-split-pane contentId="main-content">
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
